enum TipoServico {
    Correios = 1,
    Aereo = 2,
    Outros = 99,
}

export default TipoServico;
